export default __webpack_public_path__ + "static/media/picture_of_woman2.032f8ecf.png";